import { Controller } from "@hotwired/stimulus"
import Dropzone from "dropzone"
import "dropzone/dist/dropzone.css"

export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    // Dropzone automatisch auf dieses Element anwenden
    this.dropzone = new Dropzone(this.element, {
      url: this.element.dataset.uploadUrl || this.element.action || '/',
      autoProcessQueue: false,
      previewsContainer: this.hasPreviewTarget ? this.previewTarget : null,
      addRemoveLinks: true,
      dictDefaultMessage: "Dateien hierher ziehen oder klicken",
      dictRemoveFile: "Datei entfernen",
      maxFilesize: 10, // 10MB
      acceptedFiles: "image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv",
      previewTemplate: `
        <div class="dz-preview dz-file-preview flex flex-col items-center p-2">
          <div class="flex items-center gap-2">
            <i class="fas fa-file fa-2x text-gray-400"></i>
            <div class="flex flex-col items-start">
              <span class="text-xs text-gray-700 font-medium" data-dz-size></span>
              <span class="text-xs text-gray-900" data-dz-name></span>
            </div>
          </div>
          <div class="dz-error-message text-xs text-red-600 mt-1"><span data-dz-errormessage></span></div>
        </div>
      `,
      init: function() {
        this.on("addedfile", function(file) {
          // Datei zum versteckten Input hinzufügen
          const input = this.element.querySelector('input[type="file"]');
          if (input) {
            const dt = new DataTransfer();
            dt.items.add(file);
            input.files = dt.files;
          }
        });
      }
    });

  }
} 